module.exports = __webpack_public_path__ + "media/images/linkedin-f6878a94e8f6bd14524409487136630a.png";